<script setup>
// §8.3 IconButton — icon-only control. Min 24×24 target (WCAG 2.2 §2.5.8).
// Must carry an accessible label since it has no visible text.
defineProps({
  label: { type: String, required: true },
  variant: { type: String, default: 'quiet' }, // quiet | surface
  disabled: { type: Boolean, default: false },
})
</script>

<template>
  <button
    class="l-iconbtn no-tooltip-icon"
    :class="`is-${variant}`"
    :aria-label="label"
    :title="label"
    :disabled="disabled"
    type="button"
  >
    <slot />
  </button>
</template>

<style scoped>
.l-iconbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--target-min);
  height: var(--target-min);
  min-width: var(--target-min);
  min-height: var(--target-min);
  border-radius: var(--r-sm);
  border: 1px solid transparent;
  color: var(--text-2);
  cursor: pointer;
  transition: background var(--t-fast) var(--ease), color var(--t-fast) var(--ease);
}
.l-iconbtn:hover:not(:disabled) {
  background: var(--surface-sunken);
  color: var(--text);
}
.is-surface {
  border-color: var(--line);
  background: var(--surface);
}
.l-iconbtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.l-iconbtn :deep(i) {
  font-size: 16px; /* fallback; each icon also passes an explicit :size */
}
</style>
